import React from 'react';

/**
 * Groups related menu items with an optional title for the mobile menu
 * 
 * @param {React.ReactNode} children - Menu items to display
 * @param {string} title - Optional group title
 */
const MobileMenuGroup = ({ children, title }) => {
  return (
    <div className="mb-6">
      {title && (
        <div className="mb-2">
          <h3 className="text-xs font-medium uppercase tracking-wider text-slate-400 px-2">{title}</h3>
          <div className="h-px bg-gradient-to-r from-emerald-500/10 via-emerald-500/20 to-emerald-500/10 mt-1 mb-3"></div>
        </div>
      )}
      <div>
        {children}
      </div>
    </div>
  );
};

export default MobileMenuGroup;